import styled, { css } from 'styled-components';
import * as AvatarPrimitive from '@radix-ui/react-avatar'

export type Variants = {
  $borderColor: string;
  variant?: 'xs' | 'sm' | 'md' | 'lg',
}

const borderMap = {
  xs: { width: '28px', height: '28px' },
  sm: { width: '40px', height: '40px' },
  md: { width: '48px', height: '48px' },
  lg: { width: '70px', height: '70px' }
};

const avatarMap = {
  xs: { width: '26px', height: '26px' },
  sm: { width: '36px', height: '36px' },
  md: { width: '44px', height: '44px' },
  lg: { width: '64px', height: '64px' }
};

export const Container = styled.div<Variants>`
  border: 2px solid;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  border-radius: 100%;

  ${({ variant, $borderColor }) =>
    variant &&
    css`
      width: ${borderMap[variant].width};
      height: ${borderMap[variant].height};
      border-color: ${$borderColor || '#333333'};
  `}
`;

export const StyledAvatarRoot = styled(AvatarPrimitive.Root) <Variants>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  overflow: hidden;
  user-select: none;
  border-radius: 100%;
  background-color: black;

  ${({ variant }) =>
    variant &&
    css`
      width: ${avatarMap[variant].width};
      height: ${avatarMap[variant].height};
    `}
`;

export const StyledAvatarImage = styled(AvatarPrimitive.Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
`;

export const StyledAvatarFallback = styled(AvatarPrimitive.Fallback)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: violet;
  color: var(--violet-11);
  font-size: 18px;
  line-height: 1;
  font-weight: 500;
`;
